/**
 * Aplica el tema de la empresa (variables CSS `--color-*`) al documento.
 *
 * Normalmente esto lo hace `EmpresaLoader` al montar el storefront del subdominio,
 * pero las rutas que NO pasan por `EmpresaLoader` (p.ej. `/mesa/:token`) deben
 * aplicarlo por su cuenta para que las pantallas que reutilizan
 * `ClienteCatalogo.styles.js` (y sus `var(--color-*)`) se vean identicas.
 */
export function aplicarTemaEmpresa(cfg) {
  if (!cfg) return;
  const root = document.documentElement;
  root.style.setProperty('--color-primary', cfg.color_primario || '#0B1A4A');
  root.style.setProperty('--color-secondary', cfg.color_secundario || '#2952CC');
  root.style.setProperty('--color-bg', cfg.color_fondo || '#F5F7FA');
  root.style.setProperty('--color-success', cfg.color_exito || '#34a853');
  root.style.setProperty('--color-danger', cfg.color_peligro || '#ea4335');
  root.style.setProperty('--color-surface', '#FFFFFF');
  root.style.setProperty('--color-border', '#E8EAEF');
  root.style.setProperty('--color-text', '#202124');
  root.style.setProperty('--color-text-secondary', '#7A869A');
  root.style.setProperty('--color-text-muted', '#A0A8B4');
  root.style.setProperty('--color-bg-hover', '#F0F1F5');
  root.style.setProperty('--color-danger-light', '#fce8e6');
}
